export const THEME_IDS = [
  "hehel",
  "hehe-chat",
  "slate",
  "vscode",
  "docmost",
  "blender",
  "light",
] as const;

export type ThemeId = (typeof THEME_IDS)[number];

const NAMES: Record<ThemeId, string> = {
  hehel: "Hehel",
  "hehe-chat": "Hehe Chat",
  slate: "Slate",
  vscode: "VS Code",
  docmost: "Docmost",
  blender: "Blender",
  light: "Light",
};

export function parseTheme(raw: string | null | undefined): ThemeId {
  const v = String(raw || "").trim();
  return (THEME_IDS as readonly string[]).includes(v) ? (v as ThemeId) : "hehel";
}

export function readTheme(): ThemeId {
  return parseTheme(localStorage.getItem("hiera.theme"));
}

export function themeName(id: ThemeId): string {
  return NAMES[id] || NAMES.hehel;
}

export function nextTheme(id: ThemeId): ThemeId {
  const i = THEME_IDS.indexOf(id);
  return THEME_IDS[(i < 0 ? 0 : i + 1) % THEME_IDS.length];
}
